module.exports = __webpack_public_path__ + "media/images/user_avatar-bbd9e0a0e6dcd0b7d87cd94113aee7fd.png";